import { t } from "shared/localization/localization";

export const piecesText = (pieces: number): string => {
  return `${pieces} ${pieces > 1 ? t("pieces") : t("piece")}`;
};
